import React from 'react';
//import $ from 'jquery';
import _ from 'lodash';
//import * as capabilities from '../../utils/capabilities.js';


export default class WindowContext extends React.Component {
	constructor(props) {
		super(props);
		this.props=props;
		//this._handleScroll = (_.throttle(this.handleScroll,0)).bind(this);
		this._handleResize = (_.debounce(this.handleResize,0)).bind(this);
		this.state = { 
			//scrollPos: 0,
			winWidth: -1,
			winHeight: -1,
            canAutoPlayVideo: false
		}
	}
	componentDidMount() {
		if(typeof window !== "undefined") {
			//window.addEventListener('scroll', this._handleScroll);
			window.addEventListener('resize', this._handleResize);
/*			this.handleResize.bind(this)();
            capabilities.autoplayTest()
                .then((supports) => {
                    if(supports) {
                        this.setState({canAutoPlayVideo:true});    
                    }
                });*/
			this.handleResize();
			setTimeout(() => this.handleResize(),20000);
			//this.handleScroll();
		}
	}
	componentWillUnmount() {
		if(typeof window !== "undefined") {
			//window.removeEventListener('scroll', this._handleScroll);
			window.removeEventListener('resize', this._handleResize);
		}
	}
	/*handleScroll() {
		this.setState({ scrollPos: window.pageYOffset });
	}*/
	handleResize() {
		this.setState({
			winHeight: window.innerHeight || -1,
			winWidth: window.innerWidth || -1
		});
	}
	getChildContext() {
		return { 
			/*scrollPos: this.state.scrollPos,*/
			winHeight: this.state.winHeight,
			winWidth: this.state.winWidth
//            canAutoPlayVideo: this.state.canAutoPlayVideo
		}
	}
	
	render() {
		return (
			<div>{this.props.children}</div>
		);
	}
}

WindowContext.childContextTypes = {
	//scrollPos: React.PropTypes.number.isRequired,
	winWidth: React.PropTypes.number.isRequired,
	winHeight: React.PropTypes.number.isRequired
//    canAutoPlayVideo: React.PropTypes.bool.isRequired
}


// WEBPACK FOOTER //
// ./src/js/containers/WindowContext/WindowContext.jsx